<template>
  <div class="user-list" ref="main">
    <template v-if="voiceRoomDetail">
      <el-card class="admin-user-box">
        <div slot="header" class="clearfix">
          <span>{{$t('upgrade_page_views_administrator_management_index_1974')}}</span>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="addFixedUser()"
            >{{$t('upgrade_page_views_administrator_management_user_list_1976')}}</el-button
          >
        </div>
        <el-table
          :max-height="$refs.main ? $refs.main.offsetHeight - 100 : 600"
          :data="fixedUsers"
          border
          style="width: 100%"
        >
          <el-table-column prop="nickname" :label="$t('upgrade_page_views_user_info_index_722')" min-width="120">
          </el-table-column>
          <el-table-column prop="uuid" label="uuid" min-width="120">
          </el-table-column>
          <el-table-column prop="avatarUrl" :label="$t('upgrade_page_views_administrator_management_admin_list_1961')" min-width="120">
            <template slot-scope="scope">
              <el-image
                style="width: 80px; height: 80px"
                :src="scope.row.avatarUrl"
                :preview-src-list="[scope.row.avatarUrl]"
                fit="cover"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="$t('upgrade_page_views_administrator_management_admin_list_1962')" min-width="120">
            <template slot-scope="scope">
              <!-- <el-button @click="handleClick(scope.row)" type="text" size="small"
            >查看</el-button
          > -->
              <el-button
                type="danger"
                size="small"
                @click="deleteFixedUser(scope.row, scope.$index)"
                >{{$t('components_userrelation_index_238')}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>

    <el-dialog
      :title="$t('upgrade_page_views_administrator_management_user_list_1977')"
      :visible.sync="dialogVisible"
      width="320px"
      append-to-body
    >
      <el-input
        v-model="fixedUserUuid"
        :placeholder="$t('upgrade_page_views_administrator_management_admin_list_1964')"
        clearable
        @input="getUser()"
        style="margin-bottom:20px"
      />
      <div v-loading="getUserLoading">
        <div v-if="fixedUser && fixedUser.uuid">
          <el-image
            style="width: 100px; height: 100px;margin-bottom:10px "
            fit="cover"
            :src="fixedUser.avatarUrl"
          >
          </el-image>
          <div>{{ fixedUser.nickname }}</div>
        </div>
        <div v-else>{{$t('upgrade_page_views_administrator_management_admin_list_1965')}}</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('upgrade_page_views_administrator_management_admin_list_1966')}}</el-button>
        <el-button type="primary" :disabled="!fixedUser.uuid" @click="submitAdd"
          >{{$t('upgrade_page_views_administrator_management_admin_list_1967')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import i18n from '@/locales/index'
export default {
  name: 'UserList',
  props: {
    isWhiteUser: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    voiceRoomDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fixedUserUuid: '',
      fixedUser: {},
      dialogVisible: false,
      getUserLoading: false,
      tableLoading: false,
      addLoading: false
    };
  },
  computed: {
    tableHeight() {
      if (this.$refs.main && this.refs.header) {
        return (
          this.$refs.main.offsetHeight - this.$refs.header.offsetHeight - 10
        );
      } else {
        return 600;
      }
    },
    fixedUsers() {
      return this.voiceRoomDetail.fixedUsers || [];
    },
    roomUid() {
      return this.voiceRoomDetail.roomUid || '';
    }
  },
  methods: {
    deleteFixedUser(user, index) {
      const { uuid, nickname } = user;
      this.$confirm({
        content: i18n.t('upgrade_page_views_administrator_management_user_list_1978', [nickname]),
        title: i18n.t('upgrade_page_views_order_confirm_order_291'),
        showCancelButton: true,
        confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
        closeOnClickModal: false
      }).then(() => {
        this.$http
          .get('/voiceRoom/admin/unsetFixed', {
            roomUid: this.roomUid,
            uuid
          })
          .then(() => {
            this.fixedUsers.splice(index, 1);
            this.$message.success(i18n.t('upgrade_page_views_user_info_index_743'));
            // this.getVoiceRoom();
          });
      });
    },
    addFixedUser() {
      if (!this.roomUid) {
        return;
      }
      this.fixedUser = {};
      this.fixedUserUuid = '';
      this.dialogVisible = true;
    },
    submitAdd() {
      this.$http
        .get('/voiceRoom/admin/setFixed', {
          roomUid: this.roomUid,
          uuid: this.fixedUser.uuid
        })
        .then(() => {
          this.dialogVisible = false;
          this.$message.success(i18n.t('upgrade_page_views_administrator_management_admin_list_1969'));
          this.$emit('add-user-success');
        });
    },
    getUser() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getUserLoading = true;
        this.$http
          .get('/user/detail/info', { uuid: this.fixedUserUuid })
          .then(({ data }) => {
            this.fixedUser = data || {};
            this.getUserLoading = false;
          })
          .catch(() => {
            this.fixedUser = {};
            this.getUserLoading = false;
          });
      }, 1500);
    },
    editVoiceRoom() {
      if (!this.roomUid) {
        return;
      }
      this.$refs.editForm.open();
    },
    editVoiceRoomSuccess() {
      this.$emit('edit-voice-room-success');
    },
    handleOpen($event) {
      try {
        this.$http.post('/voiceRoom/admin/updateOpen', {
          open: $event,
          roomUid: this.roomUid
        });
      } catch (error) {
        this.voiceRoomDetail.open = !this.voiceRoomDetail.open;
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.user-list {
  height: 100%;
  flex: 1;
}
</style>
